namespace GeniuzPOS.Common.Helpers {

    @Serenity.Decorators.registerFormatter([Serenity.ISlickFormatter, Serenity.IInitializeColumn])
    export class AssortFgFormatter implements Slick.Formatter {

        format(ctx: Slick.FormatterContext) {
            var text = Q.htmlEncode(ctx.value);

            if (!this.chanalPropertyId) {
                return text;
            }

            let chanel = ctx.item[this.chanalPropertyId];
            // console.log('Charnel : ' + chanel);
            if (chanel == 0) {
                return "<i class='fa fa-times-circle text-danger'></i> " +
                       "<button class='btn btn-sm' style='background-color: #FFE5E5; color: #DC3545; border: none;'>ไม่คละ</button>";
            } else if (chanel == 1) {
                return "<i class='fa fa-check-circle text-success'></i> " +
                       "<button class='btn btn-sm' style='background-color: #E8F5E9; color: #28A745; border: none;'>คละได้</button>";
            }  else {
                return chanel
            }


        }

        @Serenity.Decorators.option()
        public chanalPropertyId: string;

        public initializeColumn(column: Slick.Column) {
            column.referencedFields = column.referencedFields || [];
            if (this.chanalPropertyId)
                column.referencedFields.push(this.chanalPropertyId);
        }
    }

    
    @Serenity.Decorators.registerFormatter([Serenity.ISlickFormatter, Serenity.IInitializeColumn])
    export class ItemTypeFgFormatter implements Slick.Formatter {

        format(ctx: Slick.FormatterContext) {
            var text = Q.htmlEncode(ctx.value);

            if (!this.chanalPropertyId) {
                return text;
            }

            let chanel = ctx.item[this.chanalPropertyId];
            // console.log('Charnel : ' + chanel);
            if (chanel == 1) {
                return "<i class='fa fa-gift text-primary'></i> " +
                       "<button class='btn btn-sm' style='background-color: #E3F2FD; color: #0D6EFD; border: none;'>ซื้อ&แถม</button>";
            } else if (chanel == 2) {
                return "<i class='fa fa-shopping-cart text-success'></i> " +
                       "<button class='btn btn-sm' style='background-color: #E8F5E9; color: #28A745; border: none;'>ซื้อ</button>";
            } else if (chanel == 3) {
                return "<i class='fa fa-gift text-warning'></i> " +
                       "<button class='btn btn-sm' style='background-color: #FFF3E0; color: #FD7E14; border: none;'>แถม</button>";
            } else {
                return chanel
            }


        }

        @Serenity.Decorators.option()
        public chanalPropertyId: string;

        public initializeColumn(column: Slick.Column) {
            column.referencedFields = column.referencedFields || [];
            if (this.chanalPropertyId)
                column.referencedFields.push(this.chanalPropertyId);
        }
    }

    @Serenity.Decorators.registerFormatter([Serenity.ISlickFormatter, Serenity.IInitializeColumn])
    export class PromoTimeFgFormatter implements Slick.Formatter {

        format(ctx: Slick.FormatterContext) {
            var text = Q.htmlEncode(ctx.value);

            if (!this.chanalPropertyId) {
                return text;
            }

            let chanel = ctx.item[this.chanalPropertyId];
            // console.log('Charnel : ' + chanel);
            if (chanel == 0) {
                return "<i class='fa fa-clock-o text-info'></i> " +
                       "<button class='btn btn-sm' style='background-color: #E3F2FD; color: #0DCAF0; border: none;'>ทั้งวัน</button>";
            } else if (chanel == 1) {
                return "<i class='fa fa-hourglass-half text-warning'></i> " +
                       "<button class='btn btn-sm' style='background-color: #FFF3E0; color: #FD7E14; border: none;'>ระบุเวลา</button>";
            }  else {
                return chanel
            }


        }

        @Serenity.Decorators.option()
        public chanalPropertyId: string;

        public initializeColumn(column: Slick.Column) {
            column.referencedFields = column.referencedFields || [];
            if (this.chanalPropertyId)
                column.referencedFields.push(this.chanalPropertyId);
        }
    }

    @Serenity.Decorators.registerFormatter([Serenity.ISlickFormatter, Serenity.IInitializeColumn])
    export class PromoDayChFgFormatter implements Slick.Formatter {

        format(ctx: Slick.FormatterContext) {
            var text = Q.htmlEncode(ctx.value);

            if (!this.chanalPropertyId) {
                return text;
            }

            let chanel = ctx.item[this.chanalPropertyId];
            // console.log('Charnel : ' + chanel);
            if (chanel == 0) {
                return "<i class='fa fa-calendar text-success'></i> " +
                       "<button class='btn btn-sm' style='background-color: #E8F5E9; color: #28A745; border: none;'>ทุกวัน</button>";
            } else if (chanel == 1) {
                return "<i class='fa fa-calendar-check-o text-primary'></i> " +
                       "<button class='btn btn-sm' style='background-color: #E3F2FD; color: #0D6EFD; border: none;'>ระบุวัน</button>";
            }  else {
                return chanel
            }


        }

        @Serenity.Decorators.option()
        public chanalPropertyId: string;

        public initializeColumn(column: Slick.Column) {
            column.referencedFields = column.referencedFields || [];
            if (this.chanalPropertyId)
                column.referencedFields.push(this.chanalPropertyId);
        }
    }
    @Serenity.Decorators.registerFormatter([Serenity.ISlickFormatter, Serenity.IInitializeColumn])
    export class PromoShopFgFormatter implements Slick.Formatter {

        format(ctx: Slick.FormatterContext) {
            var text = Q.htmlEncode(ctx.value);

            if (!this.chanalPropertyId) {
                return text;
            }

            let chanel = ctx.item[this.chanalPropertyId];
            // console.log('Charnel : ' + chanel);
            if (chanel == 0) {
                return "<i class='fa fa-building text-success'></i> " +
                       "<button class='btn btn-sm' style='background-color: #E8F5E9; color: #28A745; border: none;'>ทุกร้าน</button>";
            } else if (chanel == 1) {
                return "<i class='fa fa-store text-primary'></i> " +
                       "<button class='btn btn-sm' style='background-color: #E3F2FD; color: #0D6EFD; border: none;'>ระบุร้าน</button>";
            }  else {
                return chanel
            }


        }

        @Serenity.Decorators.option()
        public chanalPropertyId: string;

        public initializeColumn(column: Slick.Column) {
            column.referencedFields = column.referencedFields || [];
            if (this.chanalPropertyId)
                column.referencedFields.push(this.chanalPropertyId);
        }
    }

    @Serenity.Decorators.registerFormatter([Serenity.ISlickFormatter, Serenity.IInitializeColumn])
    export class PromoCustFgFormatter implements Slick.Formatter {

        format(ctx: Slick.FormatterContext) {
            var text = Q.htmlEncode(ctx.value);

            if (!this.chanalPropertyId) {
                return text;
            }

            let chanel = ctx.item[this.chanalPropertyId];
            
            if (chanel == 0) {
                return "<i class='fa fa-users text-success'></i> " +
                       "<button class='btn btn-sm' style='background-color: #98FB98; color: #2E8B57; border: none;'>ทั้งหมด</button>";
            } else if (chanel == 1) {
                return "<i class='fa fa-user-times text-warning'></i> " +
                       "<button class='btn btn-sm' style='background-color: #FFE4B5; color: #CD853F; border: none;'>ไม่ใช่สมาชิก</button>";
            } else if (chanel == 2) {
                return "<i class='fa fa-user text-info'></i> " +
                       "<button class='btn btn-sm' style='background-color: #B0E0E6; color: #4682B4; border: none;'>สมาชิกเท่านั้น</button>";
            } else if (chanel == 3) {
                return "<i class='fa fa-user-plus text-danger'></i> " +
                       "<button class='btn btn-sm' style='background-color: #FFB6C1; color: #CD5C5C; border: none;'>ระบุสมาชิก</button>";
            } else {
                return chanel;
            }
        }

        @Serenity.Decorators.option()
        public chanalPropertyId: string;

        public initializeColumn(column: Slick.Column) {
            column.referencedFields = column.referencedFields || [];
            if (this.chanalPropertyId)
                column.referencedFields.push(this.chanalPropertyId);
        }
    }

    @Serenity.Decorators.registerFormatter([Serenity.ISlickFormatter, Serenity.IInitializeColumn])
    export class CouponTypeFgFormatter implements Slick.Formatter {

        format(ctx: Slick.FormatterContext) {
            var text = Q.htmlEncode(ctx.value);

            if (!this.chanalPropertyId) {
                return text;
            }

            let chanel = ctx.item[this.chanalPropertyId];
            
              
            if (chanel == 1) {
                return "<i class='fa fa-percent text-success'></i> " +
                       "<button class='btn btn-sm' style='background-color: #32CD32; color: #006400; border: none;'>ลด% ทันที</button>";
            } else if (chanel == 2) {
                return "<i class='fa fa-ticket text-warning'></i> " +
                       "<button class='btn btn-sm' style='background-color: #FFA500; color: #8B4513; border: none;'>คูปองส่วนลด</button>";
            } else if (chanel == 3) {
                return "<i class='fa fa-money text-info'></i> " +
                       "<button class='btn btn-sm' style='background-color: #1E90FF; color: #00008B; border: none;'>คูปองเงินสด</button>";
            } else if (chanel == 4) {
                return "<i class='fa fa-gift text-danger'></i> " +
                       "<button class='btn btn-sm' style='background-color: #FF0000; color: #8B0000; border: none;'>คูปองแลกของกำนัล</button>";
            } else {
                return chanel;
            }
        }

        @Serenity.Decorators.option()
        public chanalPropertyId: string;

        public initializeColumn(column: Slick.Column) {
            column.referencedFields = column.referencedFields || [];
            if (this.chanalPropertyId)
                column.referencedFields.push(this.chanalPropertyId);
        }
    }
    @Serenity.Decorators.registerFormatter([Serenity.ISlickFormatter, Serenity.IInitializeColumn])
    export class AmtOrPcFgFormatter implements Slick.Formatter {

        format(ctx: Slick.FormatterContext) {
            var text = Q.htmlEncode(ctx.value);

            if (!this.chanalPropertyId) {
                return text;
            }

            let chanel = ctx.item[this.chanalPropertyId];
            
            if (chanel == 0) {
                return "<i class='fa fa-tags text-primary'></i> " +
                       "<button class='btn btn-sm' style='background-color: #E3F2FD; color: #0D6EFD; border: none;'>ราคา n ชิ้น</button>";
            } else if (chanel == 1) {
                return "<i class='fa fa-percent text-success'></i> " +
                       "<button class='btn btn-sm' style='background-color: #E8F5E9; color: #28A745; border: none;'>ส่วนลดเป็น %</button>";
            } else if (chanel == 2) {
                return "<i class='fa fa-money text-warning'></i> " +
                       "<button class='btn btn-sm' style='background-color: #FFF3E0; color: #FD7E14; border: none;'>ส่วนลดเป็นจำนวนเงิน</button>";
            } else {
                return chanel;
            }
        }

        @Serenity.Decorators.option()
        public chanalPropertyId: string;

        public initializeColumn(column: Slick.Column) {
            column.referencedFields = column.referencedFields || [];
            if (this.chanalPropertyId)
                column.referencedFields.push(this.chanalPropertyId);
        }
    }

    @Serenity.Decorators.registerFormatter([Serenity.ISlickFormatter, Serenity.IInitializeColumn])
    export class AmtOrPc3FgFormatter implements Slick.Formatter {

        format(ctx: Slick.FormatterContext) {
            var text = Q.htmlEncode(ctx.value);

            if (!this.chanalPropertyId) {
                return text;
            }

            let chanel = ctx.item[this.chanalPropertyId];
            
            if (chanel == 1) {
                return "<i class='fa fa-percent text-success'></i> " +
                       "<button class='btn btn-sm' style='background-color: #E8F5E9; color: #28A745; border: none;'>ส่วนลดเป็น %</button>";
            } else if (chanel == 2) {
                return "<i class='fa fa-money text-warning'></i> " +
                       "<button class='btn btn-sm' style='background-color: #FFF3E0; color: #FD7E14; border: none;'>ส่วนลดเป็นจำนวนเงิน</button>";
            } else {
                return chanel;
            }
        }

        @Serenity.Decorators.option()
        public chanalPropertyId: string;

        public initializeColumn(column: Slick.Column) {
            column.referencedFields = column.referencedFields || [];
            if (this.chanalPropertyId)
                column.referencedFields.push(this.chanalPropertyId);
        }
    }

    @Serenity.Decorators.registerFormatter([Serenity.ISlickFormatter, Serenity.IInitializeColumn])
    export class PromoItemTypeFgFormatter implements Slick.Formatter {

        format(ctx: Slick.FormatterContext) {
            var text = Q.htmlEncode(ctx.value);

            if (!this.chanalPropertyId) {
                return text;
            }

            let chanel = ctx.item[this.chanalPropertyId];
            
            if (chanel == 1) {
                return "<i class='fa fa-barcode text-primary'></i> " +
                       "<button class='btn btn-sm' style='background-color: #E3F2FD; color: #007BFF; border: none;'>รหัสสินค้า(Plu)</button>";
            } else if (chanel == 2) {
                return "<i class='fa fa-tag text-info'></i> " +
                       "<button class='btn btn-sm' style='background-color: #E0F7FA; color: #17A2B8; border: none;'>แบบสินค้า</button>";
            } else if (chanel == 3) {
                return "<i class='fa fa-folder text-success'></i> " +
                       "<button class='btn btn-sm' style='background-color: #E8F5E9; color: #28A745; border: none;'>หมวดสินค้า</button>";
            } else if (chanel == 4) {
                return "<i class='fa fa-folder-open text-warning'></i> " +
                       "<button class='btn btn-sm' style='background-color: #FFF3E0; color: #FD7E14; border: none;'>หมวดสินค้า-2</button>";
            } else if (chanel == 5) {
                return "<i class='fa fa-folder-o text-danger'></i> " +
                       "<button class='btn btn-sm' style='background-color: #FFEBEE; color: #DC3545; border: none;'>หมวดสินค้า-3</button>";
            } else {
                return chanel;
            }
        }

        @Serenity.Decorators.option()
        public chanalPropertyId: string;

        public initializeColumn(column: Slick.Column) {
            column.referencedFields = column.referencedFields || [];
            if (this.chanalPropertyId)
                column.referencedFields.push(this.chanalPropertyId);
        }
    }
@Serenity.Decorators.registerFormatter([Serenity.ISlickFormatter, Serenity.IInitializeColumn])
export class PromoTypeFgFormatter implements Slick.Formatter {

    format(ctx: Slick.FormatterContext) {
        var text = Q.htmlEncode(ctx.value);

        if (!this.chanalPropertyId) {
            return text;
        }

        let chanel = ctx.item[this.chanalPropertyId];
        
        if (chanel == 1) {
            return "<i class='fa fa-tag text-primary'></i> " +
                   "<button class='btn btn-sm' style='background-color: #E3F2FD; color: #007BFF; border: none;'>โปรโมชั่นแบบกำหนดราคาโปรฯ</button>";
        } else if (chanel == 2) {
            return "<i class='fa fa-percent text-info'></i> " +
                   "<button class='btn btn-sm' style='background-color: #E0F7FA; color: #17A2B8; border: none;'>โปรโมชั่นแบบ ลด %</button>";
        } else {
            return chanel;
        }
    }

    @Serenity.Decorators.option()
    public chanalPropertyId: string;

    public initializeColumn(column: Slick.Column) {
        column.referencedFields = column.referencedFields || [];
        if (this.chanalPropertyId)
            column.referencedFields.push(this.chanalPropertyId);
    }
}

}